import { Growl } from 'angular/custom/services/growl.service';
import { DATES } from 'app/_constants/dates.constant';
import * as moment from 'pkp-moment-timezone-all-years';
import * as angular from 'angular';
import { NotificationConstants } from 'angular/constants/NotificationConstants';

angular.module('app').directive('pkpAlert', pkpAlert);

function pkpAlert(
    $timeout: ng.ITimeoutService,
    $filter: ng.IFilterService,
    $rootScope: ng.IRootScopeService,
    $interpolate: ng.IInterpolateService,
    DATES: DATES,
    growl: Growl
) {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            styleClass: '@styleClass',
            type: '@',
            cssClass: '@',
            dismissible: '@',
            expandable: '=',
            expanded: '=',
            expandableEvent: '&',
            title: '@',
            autodismiss: '=?',
            autodismissEvent: '=?',
            showTimestamp: '=?',
            noInfoText: '@'
        },
        template: require('app/_directives/pkp-alert.directive.html'),
        link: linkFn
    };

    function linkFn(
        scope,
        elem,
        attr,
        ctrl,
        transclude: ng.ITranscludeFunction
    ) {
        const growlTypes: string[] = ['success', 'danger'];
        scope.isGrowlType =
            growlTypes.indexOf(scope.type) !== -1 && !scope.expandable;

        (function init() {
            scope.timestamp = $filter('date')(
                moment().toDate(),
                DATES.DATETIME_DEBUG
            );
            //if autodismiss is activated, show alert for n seconds if event is fired and then hide again
            if (scope.autodismiss) {
                if (!!scope.autodismissEvent) {
                    scope.timestamp = $filter('date')(
                        moment().toDate(),
                        DATES.DATE_DEFAULT
                    );
                    scope.$parent.$on(scope.autodismissEvent, function () {
                        startAutodismissTimer();
                    });
                } else {
                    startAutodismissTimer();
                }
            } else if (scope.isGrowlType) {
                $timeout(() => {
                    const alertVisibilityWatch = scope.$watch(
                        () =>
                            angular.element(elem[0].children[0]).is(':visible'),
                        (isVisible: boolean) => {
                            if (isVisible) {
                                startGrowl();
                                alertVisibilityWatch();
                            }
                        }
                    );
                });
            }
        })();

        function startGrowl() {
            if (!scope.autodismiss) {
                elem[0].children[0].hidden = true;
            }

            growl.show(
                $interpolate(transclude().text())(scope.$parent),
                scope.type
            );
        }

        function startAutodismissTimer() {
            scope.isGrowlType
                ? startGrowl()
                : (scope.autodismissVisible = true);

            $timeout(function () {
                !scope.isGrowlType && (scope.autodismissVisible = false);
            }, NotificationConstants.duration);
        }
    }
}
